import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  alpha,
} from '@mui/material';

function CategoryModal({ open, onClose, onSave, category }) {
  const [name, setName] = useState('');
  const [color, setColor] = useState('#2196f3');

  useEffect(() => {
    if (category) {
      setName(category.name);
      setColor(category.color);
    } else {
      setName('');
      setColor('#2196f3');
    }
  }, [category, open]);

  const handleSave = () => {
    if (!name.trim()) return;
    onSave({ name, color });
    setName('');
    setColor('#2196f3');
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{category ? 'Edit Category' : 'New Category'}</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2, width: 300 }}>
          <TextField
            autoFocus
            label="Category Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            fullWidth
            sx={{ mb: 3 }}
          />
          <Typography variant="subtitle2" gutterBottom>
            Category Color
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <input
              type="color"
              value={color}
              onChange={(e) => setColor(e.target.value)}
              style={{ width: 50, height: 50, padding: 0, border: 'none' }}
            />
            <Box
              sx={{
                flex: 1,
                p: 2,
                borderRadius: 1,
                backgroundColor: alpha(color, 0.1),
                border: `1px solid ${alpha(color, 0.2)}`,
                color: 'text.primary',
              }}
            >
              Preview
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained" disabled={!name.trim()}>
          {category ? 'Save' : 'Add'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CategoryModal;